import React from 'react';
import {connect} from 'react-redux';
import {CHARM} from "../../constants";
import Letter from '../lib/Letter';
import {Loop} from "../lib/Chain";

class OneLinePreview extends React.Component {
    render() {
        return (
            <>
                {this.props.input.length !== 0 ? (
                    <>
                        <Loop/>
                        <div className='customizer-preview__line'>
                            {this.props.input.map((letter, index) => <Letter key={index} letter={letter}/>)}
                        </div>
                    </>
                ):(
                    <div>type something</div>
                )}
            </>
        );
    }
}

class TwoLinePreview extends React.Component {
    render() {
        return (
            <>
                {(this.props.input.length !== 0 && this.props.input2.length !== 0) &&
                    <>
                        <Loop/>
                        <div className='customizer-preview__line'>
                            {this.props.input.map((letter, index) => <Letter key={index} letter={letter}/>)}
                        </div>
                        <div className='customizer-preview__line'>
                            {this.props.input2.map((letter, index) => <Letter key={index} letter={letter}/>)}
                        </div>
                    </>
                }
                {this.props.input.length === 0 &&
                    <div>type something</div>
                }
                {this.props.input2.length === 0 &&
                    <div>second line can't be empty</div>
                }
            </>
        );
    }
}

class VerticalPreview extends React.Component {
    render() {
        return (
            <>
                {this.props.input.length !== 0 ? (
                    <>
                        <Loop/>
                        {this.props.input.map((letter, index) => <Letter key={index} letter={letter}/>)}
                    </>
                ):(
                    <div>type something</div>
                )}
            </>
        );
    }
}


class PreviewContainer extends React.Component {
    render() {
        let className = '';
        className += `customizer-preview `;
        className += `customizer-preview--charm `;
        className += `customizer-preview--${this.props.orientation.description.toLowerCase().replace(' ', '-')} `;
        className += `${this.props.color.description.toLowerCase().replace(' ', '-')} `;

        return (
            <div className={className}>
                <div className="customizer-preview__container">
                    {this.props.orientation === CHARM.ONELINE &&
                        <OneLinePreview input={this.props.input} color={this.props.color}/>
                    }
                    {this.props.orientation === CHARM.TWOLINES &&
                        <TwoLinePreview input={this.props.input} input2={this.props.input2} color={this.props.color}/>
                    }
                    {this.props.orientation === CHARM.VERTICAL &&
                        <VerticalPreview input={this.props.input} color={this.props.color}/>
                    }
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        input: state.input.split(''),
        input2: state.input2.split(''),
        orientation: state.charmOrientation,
        color: state.goldColor,
    }
};

export default connect(mapStateToProps)(PreviewContainer);
